import { APP, WS_DATA } from './app.constants';

export const SCENARIOS = `${APP}_scenarios`;
export const SELECT_SCENARIO = `${SCENARIOS}/SELECT_SCENARIO`;
export const SAVE_SCENARIO = `${SCENARIOS}/SAVE_SCENARIO`;
export const DELETE_SCENARIO = `${SCENARIOS}/DELETE_SCENARIO`;
export const REFRESH_SCENARIO = `${SCENARIOS}/REFRESH_SCENARIO`;
export const START_SCENARIO = `${SCENARIOS}/START_SCENARIO`;
export const SCENARIOS_CHANGED = `${SCENARIOS}/SCENARIOS_CHANGED`;
export const GET_SCENARIOS = `${SCENARIOS}/GET_SCENARIOS`;

export const FETCH_V4_SCENARIOS = `${SCENARIOS}/FETCH_V4_SCENARIOS`;
export const REFRESH_V4_SCENARIO_LAST_TRIGGERED = `${SCENARIOS}/REFRESH_V4_SCENARIO_LAST_TRIGGERED`;
export const V4_SCENARIOS_LOADED = `${SCENARIOS}/V4_SCENARIOS_LOADED`;
export const V4_SCENARIO_DEDUP_UPDATED = `${SCENARIOS}/V4_SCENARIO_DEDUP_UPDATED`;
export const V4_SCENARIO_LAST_TRIGGERED_UPDATED = `${SCENARIOS}/V4_SCENARIO_LAST_TRIGGERED_UPDATED`;

export const WS_DATA_SCENARIO = `${WS_DATA}/scenario`;
export const WS_DATA_SCENARIOS = `${WS_DATA}/scenarios`;
export const WS_COMPATIBILITY = `${WS_DATA}/compatibility`;
